import axios from 'axios'

const instance = axios.create({
  baseURL: '../../mapclick/Server/mapclick-server.php'
});

const emailNotes = async (notes, emailInfo) => {
  const results = await instance({
    method: 'post',
    params: {
      action: "EmailData",
      fileFormat: "CSV"
    },
    data: {
      data: notes,
      email: emailInfo,
    },
  });
  //console.log(results);
  return results;
}

const getOwnerParcelList = async (ownerName) => {
  const results = await instance({
    params: {
      action: 'GetList',
      text: 'Owner Name',
      query: ownerName
    }
  })
  //console.log(results);
  const list = results.data.data.map((item) => {
    return {
      text: item.text + " " + item.value,
      value: item.value
    }
  });
  return list;
}

const getParcelsById = async (parcelId) => {
  const results = await instance({
    params: {
      action: 'Locate',
      locateType: 'Tax Number',
      value: parcelId
    }
  })
  //console.log(results);
  const list = results.data.queryResults.map((p) => {
    return {
      text: p.id,
      value: p.id
    }
  });
  return list;
}

const getParcelDetailByAddress = async (params) => {
  const locateParams = {...params, action: 'Locate', locateType: 'Address'};
  const results = await instance({params: locateParams});
  //console.log(results);
  return results.data.queryResults[0];

}

const getParcelDetailById = async (parcelId) => {
  const results = await instance({
    params: {
      action: 'Locate',
      locateType: 'Tax Number',
      value: parcelId
    }
  })
  //console.log(results);
  return results.data.queryResults[0];
}

const getParcelDetailByXY = async (coordinates, mapResolution) => {
  const options = {
    "showGeometry":true,
    "showClick":true,
    "saveKey":"Parcels",
    "tables":[
      {
        "name":"jcparcels",
        "alt_table_string":"jcparcels p Left JOIN jc_siteaddress s ON p.tag=s.st_parcel_id",
        "attributeKey":"TAX",
        "idAttribute":"tag"
        }
    ],
    "x": coordinates[0],
    "y": coordinates[1],
    "mapResolution": mapResolution
  };

  const results = await instance({
    params: {
      action: 'QueryXY',
      options: options,
    }
  })
  //console.log(results);
  return results.data.queryResults[0];
}

const getParcelMultipleLayersByXY = async (coordinates, mapResolution) => {
  const options = {
    "showGeometry":true,
    "showClick":true,
    "tables":[
      {"name":"jcparcels","attributeKey":"TAX","alt_table_string":"jcparcels p Left JOIN jc_siteaddress s ON p.tag=s.st_parcel_id","idAttribute":"tag"},
      {"name":"jctownship","attributeKey":"TAX"},
      {"name":"jcfemaindex","attributeKey":"TAX"},
      {"name":"jcwaterdistrict","attributeKey":"TAX"},
      {"name":"jcetj","attributeKey":"TAX"},
      {"name":"jccitylimit","attributeKey":"TAX"},
      {"name":"jctownzoning","attributeKey":"TAX"},
      {"name":"jccountyzoning","attributeKey":"TAX"},
      {"name":"jc_zoningoverlays","attributeKey":"TAX"},
      {"name":"jcemsdistricts","attributeKey":"TAX"},
      {"name":"jcfire","attributeKey":"TAX"},
      {"name":"jclawdistricts","attributeKey":"TAX"},
      {"name":"jccensustrct2000","attributeKey":"TAX"},
      {"name":"jcelectricpower","attributeKey":"TAX"},
      {"name":"jcvote","attributeKey":"TAX"},
      {"name":"jcspecialtaxdistricts","attributeKey":"TAX"}
    ],
    "x": coordinates[0],
    "y": coordinates[1],
    "mapResolution": mapResolution
  };

  const results = await instance({
    params: {
      action: 'QueryXY',
      queryType: 'Multiple Layers',
      options: options,
    }
  })
  //console.log(results);
  let out = results.data.queryResults[0];
  if (out) {
    out.markerLocation = [results.data.x, results.data.y];
  }
  return out;
}

const getSchoolDistrictsByXY = async (coordinates, mapResolution) => {
  const options = {
    "showClick":true,
    "includeXY": false,
    "tables":[
      {"name":"jcelemschdistrict","attributeKey":"DISTRICT"},
      {"name":"jcmiddleschdistrict","attributeKey":"DISTRICT"},
      {"name":"jchighschdistrict","attributeKey":"DISTRICT"}
    ],
    "x": coordinates[0],
    "y": coordinates[1],
    "mapResolution": mapResolution
  };

  const results = await instance({
    params: {
      action: 'QueryXY',
      queryType: "School Districts",
      options: options,
    }
  })
  //console.log(results);
  let out = results.data.queryResults[0];
  out.markerLocation = [results.data.x, results.data.y];
  return out;
}


const getZoningByXY = async (coordinates, mapResolution) => {
  const options = {
    "showClick":true,
    "noMaster":true,
    "tables":[
      {"name":"jccountyzoning","attributeKey":"ZONING"},
      {"name":"jctownzoning","attributeKey":"ZONING"},
      {"name":"jc_zoningoverlays","attributeKey":"ZONING"}
    ],
    "x": coordinates[0],
    "y": coordinates[1],
    "mapResolution": mapResolution,
  };

  const results = await instance({
    params: {
      action: 'QueryXY',
      options: options,
    }
  })
  //console.log(results);
  return results.data.queryResults[0];
}

const getStreetList = async (streetNumber, streetName) => {
  const results = await instance({
    params: {
      action: 'GetStreetNames',
      streetNumber: streetNumber,
      query: streetName
    }
  })
  //console.log(results);
  const list = results.data.data.map((street) => {
    return {
      text: street.namelong,
      value: street.namelong,
      namelong: street.namelong,
      st_city: street.st_city,
      st_name: street.st_name,
      st_post_dir: street.st_post_dir,
      st_pre_dir: street.st_pre_dir,
      st_type: street.st_type,
      streetNumber: street.streetNumber,
    }
  });
    return list;
}

const setAuthToken = (token, type='Bearer') => {
  if (token) {
   //applying token
   instance.defaults.headers.common['Authorization'] = `${type} ${token}`;
 } else {
   //deleting the token from header
   delete instance.defaults.headers.common['Authorization'];
 }
}

export default instance;

export {
  emailNotes,
  getParcelsById,
  getParcelDetailByAddress,
  getParcelDetailById,
  getParcelDetailByXY,
  getParcelMultipleLayersByXY,
  getOwnerParcelList,
  getSchoolDistrictsByXY,
  getStreetList,
  getZoningByXY,
  setAuthToken,
}
